import React, { useState, useEffect, useRef } from 'react';
import { Button, Row, Col, Modal, Form, Image, DropdownButton, Dropdown, Container, Card } from 'react-bootstrap';
import ReactTooltip from "react-tooltip";
import ReactFlagsSelect from 'react-flags-select';
import { store } from 'react-notifications-component';
import { Bounce } from 'react-activity';
import PhoneInput from 'react-phone-input-2';
import NavbarComponent from '../Navbar/index';
import RenovateTokenAlert from '../../RenovateToken';
import Backend from '../../Backend';
import Connection from '../../Calls';
import InputFile from './components/inputFile';
import HelpTool from './components/HelpTool';
import HelpToolRfc from './components/HelpToolRfc';
import ImgIDFront from '../../Images/document-ID-front.png'
import Contract from './components/contract';
import info from '../../Images/info.svg'
import Countries from '../../Countries';
import RfcLabels from './rfc_labels';
import HelpToolIcon from '../../Images/kyc/help_tools.svg';
import IconPhysics from '../../Images/kyc/persona_fisica.svg';
import IconMoral from '../../Images/kyc/persona_moral.svg';

import './index.css';

const Kyc = props => {
    // -------------- STATES --------------
    const [Entity, setEntity] = useState('');
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });
    const [wallet, setWallet] = useState(0)
    const [entityMobile, setEntityMobile] = useState('')
    const [Paso, setPaso] = useState(1);
    const [dataReject, setDataReject] = useState([]);
    const [dataRejectArrived, setDataRejectArrived] = useState(false);
    const [status, setStatus] = useState('');
    const [requestAcc, setRequestAcc] = useState('');
    const [typeHelp, setTypeHelp] = useState('');
    const [modalHelp, setModalHelp] = useState(false);
    const [modalHelpRfc, setModalHelpRfc] = useState(false);
    const [typeHelpRfc, setTypeHelpRfc] = useState('');
    const [labelRfc, setLabelRfc] = useState('');

    const [passportOrID, setPassportOrID] = useState('ID')
    const [DatosGenerales, setDatosGenerales] = useState({
        first_name :'',
        last_name_p :'',
        last_name_m :'',
        birthdate :'',
        rfc :'',
        curp :'',
        country :'',
        economic_activity :'',
        ID_Front :'',
        ID_Back :'',
        Selfie :'',
        doc_RFC:'',
        id_number:''
    })
    const [DatosDomicilio, setDatosDomicilio] = useState({
        address_country :'',
        address_state :'',
        address_municipality :'',
        address_city :'',
        address_distric :'',
        address_street :'',
        address_number_ext :'',
        address_number_int :'',
        address_zipcode:'',
        Comprobante:'',
    })
    const [DatosBancarios, setDatosBancarios] = useState({
        bank_name  :'',
        bank_intermediary :'',
        bank_address  :'',
        billing_address  :'',
        zip_code  :'',
        state  :'',
        city :'',
        bank_country :'',
        bank_id_account :'',
        bank_number_account :'',
        bank_currency :'USD',
        bank_aba :'',
        bank_swift :'',
        bank_spid :'',
        bank_clabe_account :'',
        EdoCuenta:'',
        uuid:''
    })
    const [DatosGeneralesMoral, setDatosGeneralesMoral] = useState({
        company_name:'',
        business_line:'',
        rfc_rep:'',
        birthdate_rep:'',
        country_rep:'',
        first_name:'',
        last_name_p:'',
        last_name_m:'',
        birthdate:'',
        country:'',
        rfc:'',
        curp:'',
        f_id_front:'',
        f_id_back:'',
        f_rfc:'',
        f_rfc_rep:'',
        f_last_constitutive_act:'',
        f_constitutive_act:'',
        f_id_selfie:'',
        id_number:'',
        f_public_register:''

    })
    const [rejected,SetRejected] = useState('')
    const [Chosen, setChosen]=useState('')
    const [btnText_F, setbtnText_F] = useState('Choose')
    const [btnText_M, setbtnText_M] = useState('Choose')
    const [Loading, setLoading] = useState(false)
    const [LoadingOmitir, setLoadingOmitir] = useState(false)
    const [showModal, setshowModal] = useState(false)
    const [PlanElegidoCellphone, setPlanElegidoCellphone] = useState('')
    const [Cellphone, setCellphone] = useState({cellphone:'',country:'', status:false})
    const [CodeSent, setCodeSent] = useState(false)
    const [Code, setCode] = useState('')
    const [showContract, setshowContract] = useState(false)
    const [DataContract, setDataContract] = useState({})
    const [InfoClientSaved, setInfoClientSaved] = useState({});
    const [limit , setLimit] = useState(16);
    const language = localStorage.getItem('lan');
    const myRefCountryMoral = useRef(null);
    const myRefCountry = useRef(null);
    const myRefCountryRep = useRef(null);
    const myRefCountryAddress = useRef(null);

    //---------LIFECYCLE---------

		useEffect(() => {
      getWallets();
			const handleResize = () => {
				setWindowSize({
					width: window.innerWidth,
					height: window.innerHeight
				});
			};
			window.addEventListener('resize', handleResize);
			return () => {
				window.removeEventListener('resize', handleResize);
			};
		}, []);

    useEffect(() => {
        get_client_data();
        let datos_generales = JSON.parse(localStorage.getItem('DatosGenerales'));
        let datos_domicilio = JSON.parse(localStorage.getItem('DatosDomicilio'));
        let datos_generales_moral = JSON.parse(localStorage.getItem('DatosGeneralesMoral'));
        if(datos_generales !== null){
            setDatosGenerales(datos_generales)
        }

        if(datos_generales_moral !== null){
            setDatosGeneralesMoral(datos_generales_moral)
        }

        if(datos_domicilio !== null){
            setDatosDomicilio(datos_domicilio)
        } 
    }, []);

    useEffect(() => {
        if(Entity !== ''){
            getFieldRejected();
        }
    }, [Entity, Paso])

    const getWallets = () => {
      let date = new Date(),
      confirmation = Connection.Uwx6GVhZ(),
      result = "",
      combination = Connection.RThzHrsb("XCHF101"),
      latitude = "0",
      longitude = "0";
      navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude;
      });
      result = latitude + longitude;
      Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", (response) => {
        Backend.GetWallets(localStorage.getItem("email"), localStorage.getItem("token"), "", 1, 1000, response.payload.r01, (response) => {
          if (response.status.code === '0'){
            setWallet(response.payload.length)
          } else {
            setWallet(0)
          }         
        })
      })
    }

    useEffect(() => {
        if(Entity === 'F'){
            if (Paso ===1){
                localStorage.setItem('DatosGenerales', JSON.stringify({...DatosGenerales,  ID_Front :'',
                ID_Back :'',
                Selfie :'',
                doc_RFC:'',}));
            } else{
                localStorage.removeItem('DatosGenerales')
                localStorage.setItem('DatosDomicilio', JSON.stringify({...DatosDomicilio, Comprobante: ''}));
            }
        } else if (Entity === 'M'){
            if (Paso ===1){
                localStorage.setItem('DatosGeneralesMoral', JSON.stringify({...DatosGeneralesMoral,
                    f_id_front:'',
                    f_id_back:'',
                    f_rfc:'',
                    f_rfc_rep:'',
                    f_last_constitutive_act:'',
                    f_constitutive_act:'',
                    f_id_selfie:'',
                    f_public_register:''
                
                }));
            } else {
                localStorage.removeItem('DatosGeneralesMoral')
                localStorage.setItem('DatosDomicilio', JSON.stringify(DatosDomicilio));
            }
        }
    }, [DatosGenerales, DatosGeneralesMoral, DatosDomicilio]);

    useEffect((value) => {
        if(DatosBancarios.uuid != ''){
            register_client_data()
        }
    }, [DatosBancarios.uuid])
// -------------- DID MOUNT --------------
    useEffect(() => {
        get_client_data()
        validationCellphone()
    }, [limit])
// -------------- UPDATE DATA --------------
    const updateDataGeneral = e =>{
        setDatosGenerales({
            ...DatosGenerales,
            [e.target.name]: e.target.value?.toUpperCase()
        })
    }

    const updateDataDomicilio = e =>{
        setDatosDomicilio({
            ...DatosDomicilio,
            [e.target.name]: e.target.value?.toUpperCase()
        })
    }

    const updateDataBancarios = e =>{
        setDatosBancarios({
            ...DatosBancarios,
            [e.target.name]: e.target.value
        })
    }

    const updateDataGeneralesMoral = e =>{
        e.preventDefault();
        setDatosGeneralesMoral({
            ...DatosGeneralesMoral,
            [e.target.name]: e.target.value?.toUpperCase()
        })
    }

    const updateDataGeneralDocs = (name,data) =>{
        setDatosGenerales({
            ...DatosGenerales,
            [name]: data
        })
    }

    const updateDataDomicilioDocs = (name,data) =>{
        setDatosDomicilio({
            ...DatosDomicilio,
            [name]: data
        })
    }

    const updateDataBancariaDocs = (name,data) =>{
        setDatosBancarios({
            ...DatosBancarios,
            [name]: data
        })
    }

    const updateDataGeneralesMoralDocs = (name,data) => {
        setDatosGeneralesMoral({
            ...DatosGeneralesMoral,
            [name]: data
        })
    }
// -------------- METHODS --------------

    const getFieldRejected = () => {
        if (Entity !== ''){
            let entity = {
                "F": 'personal',
                "M": 'business'
            }
            let type = entity[Entity]
            let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
            navigator.geolocation.getCurrentPosition((success, error, options) => {
                latitude = success.coords.latitude;
                longitude = success.coords.longitude
            });
            result = latitude + longitude;
            Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
                Backend.get_reject_data(localStorage.getItem('email'), localStorage.getItem('token'), type, response.payload.r01, async response => {
                    if(response.status.code === '0'){
                        const {list_rejected, kyc} = await response.payload;
                        if(list_rejected.length > 0){
                          setDataReject(list_rejected)
                          setDataRejectArrived(true);
                          cleanField(list_rejected, kyc, type)
                        }
                    }
                })
            })        
        }
    }

    const cleanField = (list, data, type) => {
        if(data.f_passport !== '' && data.f_id_front === ''){
            setPassportOrID('Passport')
        }else{
            setPassportOrID('ID')
        }
        let fields = (name) => list.filter(el => el.name === name) ;
        if (type === 'personal'){
            setDatosGenerales({
                first_name :         fields('first_name').length > 0 ? '' : data.first_name?.toUpperCase(),
                last_name_p :        fields('last_name_p').length > 0 ? '' : data.last_name_p?.toUpperCase(),
                last_name_m:         fields('last_name_m').length > 0 ? '' : data.last_name_m?.toUpperCase(),
                birthdate :          fields('birthdate').length > 0 ? '' : data.birthdate,
                rfc:                 fields('rfc').length > 0 ? '' : data.rfc?.toUpperCase(),
                curp :               fields('curp').length > 0 ? '': data.curp?.toUpperCase(),
                country:             fields('country').length > 0 ? myRefCountry.current.state.defaultCountry = '' : data.country,
                economic_activity:   fields('economic_activity').length > 0 ? '': data.economic_activity?.toUpperCase(),
                ID_Front:            fields('f_passport').length > 0 ? '': (data.f_passport != '')? data.f_passport : data.f_id_front,
                ID_Back:             fields('f_id_back').length > 0 ? '': data.f_id_back,
                Selfie :             fields('f_id_selfie').length > 0 ? '' : data.f_id_selfie,
                doc_RFC:             fields('f_rfc').length > 0 ? '' :  data.f_rfc,
                id_number:           fields('id_number').length > 0 ? '':  data.id_number?.toUpperCase()
            })
        } else {
            setDatosGeneralesMoral({
                company_name:               fields('company_name').length > 0 ? '' : data?.company_name?.toUpperCase(),
                business_line:              fields('business_line').length > 0 ? '' : data.business_line?.toUpperCase(),
                rfc_rep:                    fields('rfc_rep').length > 0 ? '' : data.rfc_rep?.toUpperCase(),
                birthdate_rep:              fields('birthdate_rep').length > 0 ? myRefCountryRep.current.state.defaultCountry = '' : data.birthdate_rep,
                country_rep:                fields('country_rep').length > 0 ? '' : data.country_rep,
                first_name:                 fields('first_name').length > 0 ? '' :  data.first_name?.toUpperCase(),
                last_name_p:                fields('last_name_p').length > 0 ? '' : data.last_name_p?.toUpperCase(),
                last_name_m:                fields('last_name_m').length > 0 ? '' : data.last_name_m?.toUpperCase(),
                birthdate:                  fields('birthdate').length > 0 ? '' : data.birthdate,
                country:                    fields('country').length > 0 ? myRefCountryMoral.current.state.defaultCountry = '' : data.country,
                rfc:                        fields('rfc').length > 0 ? '' : data.rfc?.toUpperCase(),
                curp:                       fields('curp').length > 0 ? '' : data.curp?.toUpperCase(),
                f_id_front:                 fields('f_passport').length > 0 ? {}: (data.f_passport != '')? data.f_passport : data.f_id_front,
                f_id_back:                  fields('f_id_back').length > 0 ? {}: data.f_id_back,
                f_rfc:                      fields('f_rfc').length > 0 ? {} : data.f_rfc,
                f_rfc_rep:                  fields('f_rfc_rep').length > 0 ? {} : data.f_rfc_rep,
                f_last_constitutive_act:    fields('f_last_constitutive_act').length > 0 ? {} : data.f_last_constitutive_act,
                f_constitutive_act:         fields('f_constitutive_act').length > 0 ? {} : data.f_constitutive_act,
                f_id_selfie:                fields('f_id_selfie').length > 0 ? {} : data.f_id_selfie,
                id_number:                  fields('id_number').length > 0 ? '' : data.id_number?.toUpperCase(),
                f_public_register:          fields('f_public_register').length > 0 ? {} : data.f_public_register
            })
        }
        if (Paso === 2) {
          setDatosDomicilio({
              address_country :       fields('address_country').length > 0 ? myRefCountryAddress.current.state.defaultCountry = '' : data.address_country,
              address_state :         fields('address_state').length > 0 ? '' : data.address_state,
              address_municipality :  fields('address_municipality').length > 0 ? '' : data.address_municipality,
              address_city :          fields('address_city').length > 0  ? '' : data.address_city,
              address_distric :       fields('address_distric').length > 0 ? '' : data.address_distric,
              address_street :        fields('address_street').length > 0 ? '' : data.address_street,
              address_number_ext :    fields('address_number_ext').length > 0 ? '' : data.address_number_ext,
              address_number_int :    fields('address_number_int').length > 0  ? '' : data.address_number_int,
              address_zipcode:        fields('address_zipcode').length > 0  ? '' : data.address_zipcode,
              Comprobante:            fields('f_utility_bill').length > 0 ?  '' : data.f_utility_bill,
          })
        }
    }

    const ConvertDataToSend = () => {
        switch (Paso) {
            case 1:
                if(Entity=='M'){
                    return({
                        "block": "basic",
                        "type_user":"business",
                        "first_name": DatosGeneralesMoral.first_name,
                        "last_name_p": DatosGeneralesMoral.last_name_p,
                        "last_name_m": DatosGeneralesMoral.last_name_m,
                        "birthdate": DatosGeneralesMoral.birthdate,
                        "country": DatosGeneralesMoral.country,
                        "curp": DatosGeneralesMoral.curp,
                        "company_name": DatosGeneralesMoral.company_name,
                        "business_line":DatosGeneralesMoral.business_line,
                        "rfc_rep": DatosGeneralesMoral.rfc_rep,
                        "birthdate_rep": DatosGeneralesMoral.birthdate_rep,
                        "country_rep": DatosGeneralesMoral.country_rep,
                        "rfc": DatosGeneralesMoral.rfc,
                        "id_number":DatosGeneralesMoral.id_number
                    })
                }else if(Entity=='F'){
                    return({
                        "block": "basic",
                        "type_user":"personal",
                        "first_name": DatosGenerales.first_name,
                        "last_name_p": DatosGenerales.last_name_p,
                        "last_name_m": DatosGenerales.last_name_m,
                        "birthdate": DatosGenerales.birthdate,
                        "rfc": DatosGenerales.rfc,
                        "country": DatosGenerales.country,
                        "economic_activity": DatosGenerales.economic_activity,
                        "curp": DatosGenerales.curp,
                        "id_number":DatosGenerales.id_number
                    })
                }
            break;
            case 2:
                return(
                {
                    "block": "address",
                    "type_user":(Entity == 'M')?'business':'personal',
                    "address_type": "national",
                    "address_country":DatosDomicilio.address_country,
                    "address_state":DatosDomicilio.address_state,
                    "address_municipality": DatosDomicilio.address_municipality,
                    "address_city": DatosDomicilio.address_city,
                    "address_distric":DatosDomicilio.address_distric,
                    "address_street":DatosDomicilio.address_street,
                    "address_zipcode": DatosDomicilio.address_zipcode,
                    "address_number_ext":DatosDomicilio.address_number_ext,
                    "address_number_int": DatosDomicilio.address_number_int,
                })
            case 3:
                return({
                    "block": "bank",
                    "type_user":(Entity == 'M')?'business':'personal',
                    "bank_country": "",
                    "bank_number_account":"",
                    "bank_currency":"",
                    "bank_aba": "",
                    "bank_swift":"",
                    "bank_spid": "",
                    "bank_clabe_account": "",
                    "uuid":"",
                    "bank_name":"",
                    "bank_intermediary" :"",
                    "bank_address"  :"",
                    "billing_address"  :"",
                    "zip_code"  :"",
                    "state"  :"",
                    "city" :"",
                })
            default:
                break;
        }
    }

    const addNotification = (status,msg,type) => {
        store.addNotification({
          title: status,
          message: msg,
          type: type,
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 2500,
            onScreen: true
          }
        });
    }

    const ValidationData = (skip) => {
        let lan_notifications = localStorage.getItem('lan')
        let msg = lan_notifications === 'es' ? "Verifique la información, los campos obligatorios no pueden estar vacíos" : "Verify information, required fields cannot be empty"
        switch (Paso) {
            case 1:
                if(Entity == 'M'){
                    if(DatosGeneralesMoral.company_name != ''  && DatosGeneralesMoral.country_rep != '' && DatosGeneralesMoral.business_line != '' && DatosGeneralesMoral.first_name != '' && DatosGeneralesMoral.last_name_p != ''
                    && DatosGeneralesMoral.last_name_m != '' && DatosGeneralesMoral.rfc != '' && DatosGeneralesMoral.rfc_rep != '' && DatosGeneralesMoral.country && ((DatosGeneralesMoral.country=='MX')?DatosGeneralesMoral.curp !='' : true)
                    && DatosGeneralesMoral.birthdate != '' && DatosGeneralesMoral.id_number != '' && DatosGeneralesMoral.f_rfc !== '' && DatosGeneralesMoral.f_rfc_rep !== '' ){
                        return true;
                    }else{
                        addNotification("Error!",msg,"danger");
                    }
                }else if(Entity == 'F'){
                    if(DatosGenerales.first_name != '' && DatosGenerales.last_name_p != '' && DatosGenerales.last_name_m != '' && DatosGenerales.birthdate != '' && DatosGenerales.rfc != '' && DatosGenerales.country != ''
                    && DatosGenerales.economic_activity != '' && ((DatosGenerales.country=='MX')?DatosGenerales.curp !='':true)  && DatosGenerales.id_number != '' && Object.keys(DatosGenerales.doc_RFC).length > 0){
                        return true;
                    }else{
                        addNotification("Error!",msg,"danger");
                    }
                }
                break;
            case 2:
                if(DatosDomicilio.address_country != '' && DatosDomicilio.address_state != ''  && DatosDomicilio.address_city != ''  && DatosDomicilio.address_distric != '' && DatosDomicilio.address_street != '' &&
                    DatosDomicilio.address_number_ext != '' && DatosDomicilio.address_zipcode != '' && Object.keys(DatosDomicilio.Comprobante).length > 0 ){
                        return true;
                }else{
                    addNotification("Error!",msg,"danger");
                }

                break;
            case 3:
                if(skip){
                    return true
                }else if(DatosBancarios.bank_country != ''  && DatosBancarios.bank_number_account != '' && DatosBancarios.bank_currency != ''
                        && DatosBancarios.bank_name != '' && DatosBancarios.state != '' && DatosBancarios.city != '' && DatosBancarios.zip_code != '' && DatosBancarios.bank_address != ''
                        && DatosBancarios.billing_address != ''){
                    return true
                }else{
                    addNotification("Error!",msg,"danger");
                }

                break;
            default:
                break;
        }
    }

    const handleChangeCellphone = (numero, pais) => {
        if(pais && pais.countryCode === 'mx'){
            setLimit(16)
        } else if (pais && pais.countryCode === 'aw'){
            setLimit(13)
        } else {
            setLimit(18)
        }

        setCellphone({
            cellphone: numero,
            country: pais.name
        })
    }

    const ChoosePlan = (entity) => {
        if(Cellphone.status){
            setEntity(entity)
            if( entity=='F' && btnText_M=='Continue'){
                setPaso(1)
            }else if( entity=='M' &&btnText_F=='Continue'){
                setPaso(1)
            }
            getFieldRejected()
        }else if(entity == 'Phone'){
            setEntity(PlanElegidoCellphone)
            if( entity=='F' && btnText_M=='Continue'){
                setPaso(1)
                getFieldRejected()
            }else if( entity=='M' &&btnText_F=='Continue'){
                setPaso(1)
                getFieldRejected()
            }
        }else{
            setPlanElegidoCellphone(entity)
            setshowModal(true)
        }
    }
    const clearStorageForm = () => {
        localStorage.removeItem('DatosGenerales')
        localStorage.removeItem('DatosDomicilio')
        localStorage.removeItem('DatosGeneralesMoral')
    }

    const SetStep = (info, pending_upgrade, type, type_requested) => {
        setInfoClientSaved(info.client_info)
        switch (pending_upgrade) {
            case 'False':
                if (type == 'free') {  // duda, si pongo este if y la cuenta fue completada y en el dashboard la cambian a false, entonces, con este if no va a poder llenar de nuevo los datos por que el type ya estaria definido
                    if (type_requested == "personal") {
                        if(info.client_info.block_basic != 'None'){
                            setbtnText_F('Continue')
                            setPaso(2)
                            if(info.client_info.block_address != 'None'){
                                setPaso(3)
                            }
                        }

                    }else if(type_requested == 'business'){
                        if(info.client_info.block_basic != 'None'){
                            setbtnText_M('Continue')
                            setPaso(2)
                            if(info.client_info.block_address != 'None'){
                                setPaso(3)
                            }
                        }
                    }
                }else{
                    if (type == 'personal') {
                        setChosen('personal')
                        setEntityMobile('F')
                        clearStorageForm()
                    }else if (type == 'business') {
                        setChosen('business')
                        setEntityMobile('M')
                        clearStorageForm()
                    }
                }
                break;
            case 'True':
                if (type_requested == 'personal') {
                    setChosen('personal')
                    setEntityMobile('F')
                    clearStorageForm()

                }else if (type_requested == 'business') {
                    setChosen('business')
                    setEntityMobile('M')
                    clearStorageForm()
                }
                    break;
            case 'rejected':
                getFieldRejected()
                clearStorageForm()
                break;

            default:
                break;
        }

    }

    const showContractData = () =>{
        setshowContract(true)
        
        let nombre, rfc, direccion;

        if (InfoClientSaved.block_basic =='pending') {
            nombre=`${InfoClientSaved.first_name} ${InfoClientSaved.last_name_p} ${InfoClientSaved.last_name_m}`
            rfc=InfoClientSaved.rfc
        }else{
            nombre=`${DatosGenerales.first_name} ${DatosGenerales.last_name_p} ${DatosGenerales.last_name_m}`
            rfc=DatosGenerales.rfc
        }
        if (InfoClientSaved.block_address =='pending') {
            direccion=`${InfoClientSaved.address_street} ${InfoClientSaved.address_number_ext}, ${InfoClientSaved.address_distric}, ${InfoClientSaved.address_municipality}, ${InfoClientSaved.address_state}, ${InfoClientSaved.address_country}`
        }else{
            direccion=`${DatosDomicilio.address_street} ${DatosDomicilio.address_number_ext}, ${DatosDomicilio.address_distric}, ${DatosDomicilio.address_municipality}, ${DatosDomicilio.address_state}, ${DatosDomicilio.address_country}`
        }
        setDataContract({
            Nombre: nombre ,
            ID_RFC: rfc,
            Direccion: direccion,
        })
    }

    const getCountryName = (code) => {return Countries[code]}

    const getCountryCode = (name) => {
        if(name){
            let country = Object.entries(Countries).find((obj) => {
                if(obj[1] == name)
                    return obj
                else if(obj[0] == name)
                    return obj
            });
            if(country && country[0])
                return country[0]
        }
    }

    
    const getRfcLabel = (name, entity) => {
        if (name && entity == 'F') {
            let differentLabelData = Object.entries(RfcLabels).find((obj) => {
                return obj[0] == name
            })

            if (differentLabelData) {
                return differentLabelData[1][entity] + props.traductions.kyc.form.general.RFC
            } else {
                return `RFC${props.traductions.kyc.form.general.RFC}`
            }
        } else {
            return `RFC${props.traductions.kyc.form.general.RFC}`
        }
    }

    // -------------- CALLS --------------

    const get_client_data = () => {
        let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";

        navigator.geolocation.getCurrentPosition((success, error, options) => {
            latitude = success.coords.latitude;
            longitude = success.coords.longitude
        });

        result = latitude + longitude;

        Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
            Backend.get_client_data(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r01, response => {
                if(response.status.code == '0'){
                  let entity={
                    'personal': 'F',
                    'business': 'M',
                    "-": ""
                  }
                  let ClientInfo = response.payload.client_info;
                  setStatus(ClientInfo.pending_upgrade)
                  setRequestAcc(ClientInfo.type_requested)
                  setEntityMobile(entity[ClientInfo.type_requested])
                  let datos_generales = JSON.parse(localStorage.getItem('DatosGenerales'));
                  let datos_domicilio = JSON.parse(localStorage.getItem('DatosDomicilio'));
                    
                    if (ClientInfo && ClientInfo.pending_upgrade !== 'False') {
                        if(ClientInfo.type_requested === 'personal'){
                            setDatosGenerales(ClientInfo)
                        } else {
                            setDatosGeneralesMoral(ClientInfo)
                        }
                        setDatosDomicilio(ClientInfo)
                    } else { 
                        if(datos_generales !== null){
                            setDatosGenerales(datos_generales)
                        }
                        if(datos_domicilio !== null){
                            setDatosDomicilio(datos_domicilio)
                        }
                    }

                    localStorage.setItem("user_name", ClientInfo.first_name);
                    localStorage.setItem(
                        "user_first_last_name",
                        ClientInfo.last_name_p
                    );
                    localStorage.setItem(
                        "user_second_last_name",
                        ClientInfo.last_name_m
                    );
                    if (ClientInfo?.country == "Mexico") {
                        localStorage.setItem("mx", "true");
                    }

                    if (props.data.history.location.state) {
                        if (props.data.history.location.state.type_requested === 'personal') {
                            setEntity('F')
                            setEntityMobile('F')
                        } else if (props.data.history.location.state.type_requested === 'business') {
                            setEntity('M')
                            setEntityMobile('M')
                        }
                    }
                    SetStep(response.payload, response.payload.client_info.pending_upgrade, response.payload.client_info.type, response.payload.client_info.type_requested)
                }
            });
        });
        
    }

    const stepSkip = () => {
        let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
        navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude
        });
        result = latitude + longitude;
        let data = {
            "block": "bank",
            "type_user":(Entity == 'M')?'business':'personal',
            "bank_country": "",
            "bank_number_account":"",
            "bank_currency":"",
            "bank_aba": "",
            "bank_swift":"",
            "bank_spid": "",
            "bank_clabe_account": "",
            "uuid":"",
            "bank_name":"",
            "bank_intermediary" :"",
            "bank_address"  :"",
            "billing_address"  :"",
            "zip_code"  :"",
            "state"  :"",
            "city" :"",
        };

        Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
            Backend.register_client_data(localStorage.getItem('email'), localStorage.getItem('token'),data, response.payload.r01, response => {
                if (response.status.code === "0"){
                    return;
                }
                setshowContract(false)
            })
        })
    }


    const register_client_data = () => {
            let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
            navigator.geolocation.getCurrentPosition((success, error, options) => {
            latitude = success.coords.latitude;
            longitude = success.coords.longitude
            });

            result = latitude + longitude;

            let data = ConvertDataToSend();
            Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
                Backend.register_client_data(localStorage.getItem('email'), localStorage.getItem('token'),data, response.payload.r01, response => {
                    if (response.status.code === "0"){
                        setPaso(Paso+1)
                        setshowContract(false)
                    }else if(response.status.code === "4114"){
                        addNotification("Validation...", "check data" , "default")
                    } else {
                        addNotification("Error!",response.status.description,"danger");

                    }
                    setLoading(false)
                    setLoadingOmitir(false)
                });
            });

    }

    const Final = async (skip) => {
        if(skip)
        setLoadingOmitir(true)
        else
        setLoading(true)
        if(ValidationData(skip)){
            switch (Paso) {
                case 1:
                    if(rejected){
                        if(Entity == 'M'){
                            let Data=DatosGeneralesMoral;
                            let promise_idFront,promise_idBack, promise_Selfie, promise_rfc,promise_rfc_rep,promise_constitutive,promise_lastConstitutive,promise_publicRegister;

                            if(passportOrID == 'ID'){
                                if(DatosGeneralesMoral.f_id_front.img ){
                                    promise_idFront = new Promise ((resolve,reject) => upload_file(DatosGeneralesMoral.f_id_front, 'f_id_front', resolve)).then(value =>{
                                        if(value) Data.f_id_front.correctUpload=true
                                        return value;
                                    })
                                }else{
                                    promise_idFront=true
                                }
                                if(DatosGeneralesMoral.f_id_back.img ){
                                    promise_idBack = new Promise ((resolve,reject) => upload_file(DatosGeneralesMoral.f_id_back, 'f_id_back', resolve)).then(value =>{
                                        if(value) Data.f_id_back.correctUpload=true
                                        return value;
                                    })
                                }else{
                                    promise_idBack=true
                                }
                            }else{
                                if(DatosGeneralesMoral.f_id_front.img ){
                                    promise_idFront = new Promise ((resolve,reject) => upload_file(DatosGeneralesMoral.f_id_front, 'f_passport', resolve)).then(value =>{
                                        if(value) Data.f_id_front.correctUpload=true
                                        return value;
                                    })
                                }else{
                                    promise_idFront=true
                                }
                                promise_idBack = true;
                            }

                            if(DatosGeneralesMoral.f_rfc.img ){
                                promise_rfc = new Promise ((resolve,reject) => upload_file(DatosGeneralesMoral.f_rfc, 'f_rfc', resolve)).then(value =>{
                                    if(value) Data.f_rfc.correctUpload=true
                                    return value;
                                })
                            }else{
                                promise_rfc=true
                            }

                            if(DatosGeneralesMoral.f_id_selfie.img ){
                                promise_Selfie = new Promise ((resolve,reject) => upload_file(DatosGeneralesMoral.f_id_selfie, 'f_id_selfie', resolve)).then(value =>{
                                    if(value) Data.f_id_selfie.correctUpload=true
                                    return value;
                                })
                            }else{
                                promise_Selfie=true

                            }
                            if(DatosGeneralesMoral.f_rfc_rep.img ){
                                promise_rfc_rep = new Promise ((resolve,reject) => upload_file(DatosGeneralesMoral.f_rfc_rep, 'f_rfc_rep', resolve)).then(value =>{
                                    if(value) Data.f_rfc_rep.correctUpload=true
                                    return value;
                                })
                            }else{
                                promise_rfc_rep=true

                            }
                            if(DatosGeneralesMoral.f_constitutive_act.img ){
                                promise_constitutive = new Promise ((resolve,reject) => upload_file(DatosGeneralesMoral.f_constitutive_act, 'f_constitutive_act', resolve)).then(value =>{
                                    if(value) Data.f_constitutive_act.correctUpload=true
                                    return value;
                                })
                            }else{
                                promise_constitutive=true

                            }


                            if(DatosGeneralesMoral.f_last_constitutive_act.img){
                                promise_lastConstitutive = new Promise ((resolve,reject) => upload_file(DatosGeneralesMoral.f_last_constitutive_act, 'f_last_constitutive_act', resolve)).then(value =>{
                                    if(value) Data.f_last_constitutive_act.correctUpload=true
                                    return value;
                                })
                            }else{
                                promise_lastConstitutive=true;
                            }

                            if(DatosGeneralesMoral.f_public_register.img ){
                                promise_publicRegister = new Promise ((resolve,reject) => upload_file(DatosGeneralesMoral.f_public_register, 'f_public_register', resolve)).then(value =>{
                                    if(value) Data.f_public_register.correctUpload=true
                                    return value;
                                })
                            }else{
                                promise_publicRegister=true

                            }


                            await Promise.all([promise_idFront, promise_idBack, promise_Selfie, promise_rfc, promise_rfc_rep, promise_constitutive, promise_lastConstitutive,promise_publicRegister])
                            .then(values => {
                                if(values.every((value)=> value == true)){
                                        setDatosGeneralesMoral(Data)
                                        register_client_data()
                                }else{
                                        // addNotification("Error!", "The necessary documents to upload are missing","danger");
                                        setLoading(false)
                                }
                                }
                            );
                        }else if(Entity == 'F'){
                            let Data=DatosGenerales;
                            let promise_idFront,promise_idBack, promise_rfc, promise_Selfie;

                            if(passportOrID == 'ID'){
                                if(DatosGenerales.ID_Front.img ){
                                    promise_idFront = new Promise ((resolve,reject) => upload_file(DatosGenerales.ID_Front, 'f_id_front', resolve)).then(value =>{
                                        if(value) Data.ID_Front.correctUpload=true
                                        return value;
                                    })
                                }else{
                                    promise_idFront=true
                                }
                                if(DatosGenerales.ID_Back.img ){
                                    promise_idBack = new Promise ((resolve,reject) => upload_file(DatosGenerales.ID_Back, 'f_id_back', resolve)).then(value =>{
                                        if(value) Data.ID_Back.correctUpload=true
                                        return value;
                                    })
                                }else{
                                    promise_idBack=true
                                }
                            }else{
                                if(DatosGenerales.ID_Front.img ){
                                    promise_idFront = new Promise ((resolve,reject) => upload_file(DatosGenerales.ID_Front, 'f_passport', resolve)).then(value =>{
                                        if(value) Data.ID_Front.correctUpload=true
                                        return value;
                                    })
                                }else{
                                    promise_idFront=true
                                }
                                promise_idBack = true;
                            }

                            if(DatosGenerales.doc_RFC.img){
                                promise_rfc = new Promise ((resolve,reject) => upload_file(DatosGenerales.doc_RFC, 'f_rfc', resolve)).then(value =>{
                                    if(value) Data.doc_RFC.correctUpload=true
                                    return value;
                                })
                            }else{
                                promise_rfc = true;
                            }

                            if(DatosGenerales.Selfie.img ){
                                promise_Selfie = new Promise ((resolve,reject) => upload_file(DatosGenerales.Selfie, 'f_id_selfie', resolve)).then(value =>{
                                    if(value) Data.Selfie.correctUpload=true
                                    return value;
                                })
                            }else{
                                promise_Selfie=true
                            }

                            await Promise.all([promise_idFront,promise_idBack,promise_Selfie,promise_rfc])
                            .then(values => {
                                if(values.every((value)=> value == true)){
                                    setDatosGenerales(Data)
                                        register_client_data()
                                }else{
                                    setLoading(false)
                                        // addNotification("Error!", "The necessary documents to upload are missing","danger");
                                }
                                }
                            );
                        }
                    }else{
                        if(Entity == 'M'){
                            let Data=DatosGeneralesMoral;
                            let promise_idFront,promise_idBack, promise_Selfie, promise_rfc,promise_rfc_rep,promise_constitutive,promise_lastConstitutive,promise_publicRegister;
                            if(passportOrID == 'ID'){
                                promise_idFront = new Promise ((resolve,reject) => upload_file(DatosGeneralesMoral.f_id_front, 'f_id_front', resolve)).then(value =>{
                                    if(value) Data.f_id_front.correctUpload=true
                                    return value;
                                })
                                promise_idBack = new Promise ((resolve,reject) => upload_file(DatosGeneralesMoral.f_id_back, 'f_id_back', resolve)).then(value =>{
                                    if(value) Data.f_id_back.correctUpload=true
                                    return value;
                                })
                            }else{
                                promise_idFront = new Promise ((resolve,reject) => upload_file(DatosGeneralesMoral.f_id_front, 'f_passport', resolve)).then(value =>{
                                    if(value) Data.f_id_front.correctUpload=true
                                    return value;
                                })
                                promise_idBack = true;
                            }

                            promise_rfc = new Promise ((resolve,reject) => upload_file(DatosGeneralesMoral.f_rfc, 'f_rfc', resolve)).then(value =>{
                                if(value) Data.f_rfc.correctUpload=true
                                return value;
                            })

                            promise_Selfie = new Promise ((resolve,reject) => upload_file(DatosGeneralesMoral.f_id_selfie, 'f_id_selfie', resolve)).then(value =>{
                                if(value) Data.f_id_selfie.correctUpload=true
                                return value;
                            })

                            promise_rfc_rep = new Promise ((resolve,reject) => upload_file(DatosGeneralesMoral.f_rfc_rep, 'f_rfc_rep', resolve)).then(value =>{
                                if(value) Data.f_rfc_rep.correctUpload=true
                                return value;
                            })

                            promise_constitutive = new Promise ((resolve,reject) => upload_file(DatosGeneralesMoral.f_constitutive_act, 'f_constitutive_act', resolve)).then(value =>{
                                if(value) Data.f_constitutive_act.correctUpload=true
                                return value;
                            })

                            if(DatosGeneralesMoral.f_last_constitutive_act.img){
                                promise_lastConstitutive = new Promise ((resolve,reject) => upload_file(DatosGeneralesMoral.f_last_constitutive_act, 'f_last_constitutive_act', resolve)).then(value =>{
                                    if(value) Data.f_last_constitutive_act.correctUpload=true
                                    return value;
                                })
                            }else{
                                promise_lastConstitutive=true;
                            }

                            if(DatosGeneralesMoral.country == 'MX'){
                                promise_publicRegister = new Promise ((resolve,reject) => upload_file(DatosGeneralesMoral.f_public_register, 'f_public_register', resolve)).then(value =>{
                                    if(value) Data.f_public_register.correctUpload=true
                                    return value;
                                })
                            }else{
                                if(DatosGeneralesMoral.f_public_register.img){
                                    promise_publicRegister = new Promise ((resolve,reject) => upload_file(DatosGeneralesMoral.f_public_register, 'f_public_register', resolve)).then(value =>{
                                        if(value) Data.f_public_register.correctUpload=true
                                        return value;
                                    })
                                }else{
                                    promise_publicRegister=true
                                }
                            }

                            await Promise.all([promise_idFront, promise_idBack, promise_Selfie, promise_rfc, promise_rfc_rep, promise_constitutive, promise_lastConstitutive,promise_publicRegister])
                            .then(values => {
                                if(values.every((value)=> value == true)){
                                        setDatosGeneralesMoral(Data)
                                        register_client_data()
                                }else{
                                        // addNotification("Error!", "The necessary documents to upload are missing","danger");
                                        setLoading(false)
                                }
                                }
                            );

                        }else if(Entity == 'F'){
                            let Data=DatosGenerales;
                            let promise_idFront,promise_idBack, promise_rfc, promise_Selfie;

                            if(passportOrID == 'ID'){
                                promise_idFront = new Promise ((resolve,reject) => upload_file(DatosGenerales.ID_Front, 'f_id_front', resolve)).then(value =>{
                                    if(value) Data.ID_Front.correctUpload=true
                                    return value;
                                })
                                promise_idBack = new Promise ((resolve,reject) => upload_file(DatosGenerales.ID_Back, 'f_id_back', resolve)).then(value =>{
                                    if(value) Data.ID_Back.correctUpload=true
                                    return value;
                                })
                            }else{
                                promise_idFront = new Promise ((resolve,reject) => upload_file(DatosGenerales.ID_Front, 'f_passport', resolve)).then(value =>{
                                    if(value) Data.ID_Front.correctUpload=true
                                    return value;
                                })
                                promise_idBack = true;
                            }

                            if(DatosGenerales.doc_RFC.img){
                                promise_rfc = new Promise ((resolve,reject) => upload_file(DatosGenerales.doc_RFC, 'f_rfc', resolve)).then(value =>{
                                    if(value) Data.doc_RFC.correctUpload=true
                                    return value;
                                })
                            }else{
                                promise_rfc = true;
                            }

                            promise_Selfie = new Promise ((resolve,reject) => upload_file(DatosGenerales.Selfie, 'f_id_selfie', resolve)).then(value =>{
                                if(value) Data.Selfie.correctUpload=true
                                return value;
                            })


                            await Promise.all([promise_idFront,promise_idBack,promise_Selfie,promise_rfc])
                            .then(values => {
                                if(values.every((value)=> value == true)){
                                    setDatosGenerales(Data)
                                        register_client_data()
                                }else{
                                    setLoading(false)
                                        // addNotification("Error!", "The necessary documents to upload are missing","danger");
                                }
                                }
                            );
                        }
                    }

                    break;
                case 2:
                    setshowContract(true);
                    showContractData()    
                    break;
                case 3:
                    if(skip){
                        new Promise ((resolve,reject) => {
                            setDatosBancarios({
                                bank_country :'',
                                bank_id_account :'',
                                bank_number_account :'',
                                bank_currency :'',
                                bank_aba :'',
                                bank_swift :'',
                                bank_spid :'',
                                bank_clabe_account :'',
                                EdoCuenta:'',
                                uuid:''
                            })
                        }).then(
                            register_client_data(true)
                        )
                    }
                default:
                    break;
            }
        }else{
            setLoading(false)
        }
    }

    const upload_file = (file, name, resolve) => {
        let msgError = language === 'es' ? "Faltan los documentos necesarios para subir" : "The necessary documents to upload are missing"
        if (file != '' && file.img_b64 || file.img && name && !file.correctUpload) {

            let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
            navigator.geolocation.getCurrentPosition((success, error, options) => {
                latitude = success.coords.latitude;
                longitude = success.coords.longitude
            });

            result = latitude + longitude;

            Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
                Backend.upload_file(localStorage.getItem('email'), localStorage.getItem('token'),file,name,response.payload.r01, response => {
                  if (response.status.code === "0"){
                    addNotification("Success!",response.payload.message,"success");
                    if(response.payload.uuid){
                        updateDataBancariaDocs("uuid",response.payload.uuid)
                    }
                    else{
                        resolve(true)
                    }
                  }else{
                    addNotification("Error!",response.status.description,"danger");
                    resolve(false)
                  }

                });
            });

        }else{
            if(file.correctUpload){
                resolve(true)
            }else{
                addNotification("Error!", msgError,"danger");
                resolve(false)
            }
        }
    }

    const validationCellphone = () => {
        setLoading(true)
        const self = this;

        let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";

        navigator.geolocation.getCurrentPosition((success, error, options) => {
          latitude = success.coords.latitude;
          longitude = success.coords.longitude
        });
        result = latitude + longitude;

        Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
          Backend.PlanCellphoneStatus(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r01, response => {
            if (response.status.code === "0"){
                setCellphone({
                    cellphone:'',
                    country:'',
                    status:(response.payload.cellphone_verified == 'True')?true:false
                })
                setLoading(false)

            }else{
                addNotification("Error!",response.status.description,"danger");
                setLoading(false)
            }

          });
        });
    }

    const SendCode = () => {
        setLoading(true)
        if (Cellphone.cellphone !== "") {
            let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";

            navigator.geolocation.getCurrentPosition((success, error, options) => {
              latitude = success.coords.latitude;
              longitude = success.coords.longitude
            });

            result = latitude + longitude;

            Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
              Backend.PlanCellphoneValidation(localStorage.getItem('email'), localStorage.getItem('token'), Cellphone.cellphone, "sending", Cellphone.country, response.payload.r01, response => {
                if (response.status.code === "0"){

                    addNotification("Success!",response.payload.message,"success");
                    setLoading(false)
                    setCodeSent(true)
                }else{
                    setLoading(false)
                    addNotification("Error!",response.status.description,"danger");
                }
              });
            });
        } else {
            addNotification("Error!",'Capture the cell phone number.',"danger");
            setLoading(false)
        }
    }

    const ValidatePhone = () => {
        setLoading(true)

        if (Code !== "") {
            let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";

            navigator.geolocation.getCurrentPosition((success, error, options) => {
              latitude = success.coords.latitude;
              longitude = success.coords.longitude
            });

            result = latitude + longitude;

            Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
              Backend.PlanCellphoneValidation(localStorage.getItem('email'), localStorage.getItem('token'), Cellphone.cellphone, Code, Cellphone.country, response.payload.r01, response => {
                if (response.status.code === "0"){
                    addNotification("Success!",response.payload.message,"success");
                    ChoosePlan('Phone')
                    setshowModal(false)
                    setLoading(false)
                    setCellphone({
                        ...Cellphone,
                        status:true
                    })
                }else{
                    addNotification("Error!",response.status.description,"danger");
                    setLoading(false)
                }
              });
            });
        } else {
            addNotification("Error!",'Capture the code number.',"danger");
            setLoading(false)
        }
    }
    const handleValidation = () => {
      Final(true);
    }

    const uploadContract = (contract) => {
        let msg = language === 'es' ? "Contrato firmado" : 'Signed contract'
        let msg_err = language === 'es' ? "Algo salió mal " : 'Something wrong'
        setLoading(true)
        let file ={
            base64Type:'pdf',
            base64:contract
        }

        if(contract !== ''){
            let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
            navigator.geolocation.getCurrentPosition((success, error, options) => {
                latitude = success.coords.latitude;
                longitude = success.coords.longitude
            });
    
            result = latitude + longitude;

            Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
                Backend.upload_file(localStorage.getItem('email'), localStorage.getItem('token'),file,'f_contract',response.payload.r01, response => {
                    if (response.status.code === "0"){
                        addNotification("Success!",msg,"success");
                        new Promise ((resolve,reject) => upload_file(DatosDomicilio.Comprobante, 'f_utility_bill', resolve)).then(value =>{
                            if(value){
                                updateDataDomicilioDocs("Comprobante",{...DatosDomicilio.Comprobante,correctUpload:true})
                                register_client_data()
                            } else{
                                setLoading(false)
                            }
                        })
                        setPaso(Paso+1)
                        setshowContract(false)
                        stepSkip()
                        clearStorageForm();
                    }else{
                        addNotification("Error!",response.status.description,"danger");
                        setLoading(false)
                    }
                })
            });
        } else {
            setLoading(false)
            addNotification("Error!",msg_err,"danger");
        }
    }

// -------------- RENDERS --------------
    const renderForms = () =>{
        return(
            <div className="container-transactions" style={{ width: "100%", display:'flex', justifyContent:'center', flexDirection:'column' }}>
                <div className='pasos'>
                    <div className='columnaPaso'>
                        <div id={(Paso==1)?'Last':''} className={(Paso >= 1)?'PasoCompleto':'PadoIncompleto'} style={{display:'flex'}}>
                            <hr/>
                            <p>1</p>
                            <hr/>
                        </div>
                        <p>{props.traductions.kyc.form.header_1}</p>
                    </div>
                    <div className='columnaPaso'>
                        <div id={(Paso==2)?'Last':''} className={(Paso >= 2)?'PasoCompleto':'PadoIncompleto'} style={{display:'flex'}}>
                            <hr/>
                            <p>2</p>
                            <hr/>
                        </div>
                        <p>{props.traductions.kyc.form.header_2}</p>
                    </div>
                </div>
                <div className='formulario'>
                    {renderContenidoFormulario()}
                </div>
            </div>
        )
    }
    const getPlaceholder = () => {
        let getLang = localStorage.getItem('lan')
        if (getLang === 'es'){
            return 'Buscar un país'
        }else {
            return "Search for a country"
        }
    }

    const handleHelpTool = (name, rfc_label = '') => {
        setModalHelp(true)
        setLabelRfc(rfc_label)
        setTypeHelp(name)
    }

    const handleHelpToolRfc = (name, label) => {
      setModalHelpRfc(true)
      setLabelRfc(label)
      setTypeHelpRfc(name)
    }

    const renderContenidoFormulario = () =>{
        switch (Paso) {
            case 1:
                if(Entity == 'M'){
                    return(
                        renderFormularioMoral()
                    )
                }else if(Entity == 'F'){
                    return(
                        renderFormularioFisica()
                    )
                }
                break;
            case 2:
                return(
                    <>
                        <Row>
                            <Col xs={12} sm={6}>
                                <Form.Group>
                                    <Form.Label className={`label-blue-kyc ${labelReject('address_country')}`}>{props.traductions.kyc.form.address.country} *</Form.Label>
                                    <center>
                                        <ReactFlagsSelect
                                            ref={myRefCountryAddress}
                                            className={styleRejectedField('address_country', 'select') || "input-Country"}
                                            searchable={true}
                                            placeholder={language === 'es' ? 'Seleccione un país': 'Select a country'}
                                            searchPlaceholder={getPlaceholder()}
                                            defaultCountry={(DatosDomicilio.address_country != '') && getCountryCode(DatosDomicilio.address_country) }
                                            selected={getCountryCode(DatosDomicilio.address_country)}
                                            onSelect={countryCode => {updateDataDomicilioDocs('address_country', getCountryName(countryCode))}}
                                            countries={["AL", "KP", "TM", "RU", "UA", "ET", "ID", "KE", "VN", "BB",
                                              "BF", "KH", "KY", "GI", "HT", "JO", "ML", "MT", "MA", "MZ", "MM", "NI",
                                              "NG", "PK", "PA", "PH","SN", "SS", "ZA", "SY", "TZ",
                                              "TR", "UG", "ZW", "VE", "AE","CD", "CG"
                                            ]}
                                            blackList={true}
                                        />
                                    </center>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={6}>
                                <Form.Group>
                                    <Form.Label className={`label-blue-kyc Info ${labelReject('address_state')}`}>
                                        <p style={{fontSize: 16, fontFamily:'DMSans-Regular'}}>{props.traductions.kyc.form.address.state} *</p>
                                    {/* Tooltip */}
                                        <a data-tip data-for="Satate">
                                            <Image src={info} />
                                        </a>
                                        <ReactTooltip id="Satate" >
                                                <span>{props.traductions.kyc.form.address.T_state}</span>
                                        </ReactTooltip>
                                    {/* END Tooltip */}

                                    </Form.Label>
                                    <Form.Control value={DatosDomicilio.address_state} onChange={updateDataDomicilio}  className={styleRejectedField('address_state')} type="text" name='address_state' placeholder={props.traductions.kyc.form.address.P_state} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={6}>
                                <Form.Group>
                                    <Form.Label className={`label-blue-kyc Info ${labelReject('address_municipality')}`}>
                                        <p style={{fontSize: 16}}>{props.traductions.kyc.form.address.delegation} </p>
                                        {/* Tooltip */}
                                            <a data-tip data-for="Municipality">
                                                <Image src={info} />
                                            </a>
                                            <ReactTooltip id="Municipality" >
                                                <span>{props.traductions.kyc.form.address.T_delegation}</span>
                                            </ReactTooltip>
                                        {/* END Tooltip */}
                                    </Form.Label>
                                    <Form.Control value={DatosDomicilio.address_municipality} onChange={updateDataDomicilio} className={styleRejectedField('address_municipality')} type="text"  name='address_municipality' placeholder={props.traductions.kyc.form.address.P_delegation} />
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={6}>
                                <Form.Group>
                                    <Form.Label className={`label-blue-kyc ${labelReject('address_city')}`}>{props.traductions.kyc.form.address.city} *</Form.Label>
                                    <Form.Control value={DatosDomicilio.address_city} onChange={updateDataDomicilio} className={styleRejectedField('address_city')} type="text"  name='address_city' placeholder={props.traductions.kyc.form.address.city} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={6}>
                                <Form.Group>
                                    <Form.Label className={`label-blue-kyc Info ${labelReject('address_distric')}`}>
                                        <p style={{fontSize: 16}}>{props.traductions.kyc.form.address.Neighborhood} *</p>
                                        {/* Tooltip */}
                                            <a data-tip data-for="ResidentialComplex">
                                                <Image src={info} />
                                            </a>
                                            <ReactTooltip id="ResidentialComplex" >
                                                <span>{props.traductions.kyc.form.address.T_Neighborhood}</span>
                                            </ReactTooltip>
                                        {/* END Tooltip */}

                                    </Form.Label>
                                    <Form.Control value={DatosDomicilio.address_distric} onChange={updateDataDomicilio} className={styleRejectedField('address_distric')} type="text"  name='address_distric' placeholder={props.traductions.kyc.form.address.P_Neighborhood} />
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={6}>
                                <Form.Group>
                                    <Form.Label className={`label-blue-kyc ${labelReject('address_street')}`}>{props.traductions.kyc.form.address.Street}</Form.Label>
                                    <Form.Control value={DatosDomicilio.address_street} onChange={updateDataDomicilio}  className={styleRejectedField('address_street')} type="text" name='address_street' placeholder={props.traductions.kyc.form.address.P_Street} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={6}>
                                <Form.Group>
                                    <Form.Label className={`label-blue-kyc ${labelReject('address_number_ext')}`}>{props.traductions.kyc.form.address.BuildingNumber}</Form.Label>
                                    <Form.Control value={DatosDomicilio.address_number_ext} onChange={updateDataDomicilio}  className={styleRejectedField('address_number_ext')} type="text" name='address_number_ext' placeholder={props.traductions.kyc.form.address.BuildingNumber} />
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={6}>
                                <Form.Group>
                                    <Form.Label className={`label-blue-kyc ${labelReject('address_number_int')}`}>{props.traductions.kyc.form.address.Apartament} ({props.traductions.kyc.form.general.optional})</Form.Label>
                                    <Form.Control value={DatosDomicilio.address_number_int} onChange={updateDataDomicilio} className={styleRejectedField('address_number_int')} type="text"  name='address_number_int' placeholder={props.traductions.kyc.form.address.Apartament} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={6}>
                                <Form.Group>
                                    <Form.Label className={`label-blue-kyc ${labelReject('address_zipcode')}`}>{props.traductions.kyc.form.address.ZipCode}</Form.Label>
                                    <Form.Control value={DatosDomicilio.address_zipcode} onChange={updateDataDomicilio} className={styleRejectedField('address_zipcode')} type="text"  name='address_zipcode' placeholder={props.traductions.kyc.form.address.ZipCode} />
                                </Form.Group>
                            </Col>
                            <Col xs={12}/>
                            <Col xs={12} sm={6}>
                                <Form.Group>
                                    <Form.Label className={`label-blue-kyc ${labelReject('f_utility_bill')}`}>{props.traductions.kyc.form.address.ProofAddress} <Image src={HelpToolIcon} width={20} height={15} style={{marginTop: '-3px', cursor: 'pointer'}} onClick={() => handleHelpTool('f_utility_bill')}/></Form.Label>
                                    <InputFile label={ props.traductions.kyc.form.address.ProofAddress} name={'f_utility_bill'} className={styleRejectedField('f_utility_bill', 'file')} cleanField={cleanInputFile('f_utility_bill')} list={dataReject} image={ImgIDFront} setImage={e => updateDataDomicilioDocs('Comprobante', e)} cleanInputFile={cleanInputFile('f_utility_bill')}/>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row style={{justifyContent:'flex-end', margin: '10px 0'}} >
                            <Button className="continue-btn" disabled={Loading} onClick={() => handleValidation()}>
                                {
                                    (Loading)
                                    ? <Bounce size={20} color={"#FFFFFF"} animating={true} />
                                    : props.traductions.kyc.form.general.Continue
                                }
                            </Button>
                        </Row>
                    </>
                )
            case 3:
                return(
                    <>
                      {
                        wallet > 0 ?
                          <div style={{height:200,display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column'}}>
                            <p className="invoices-card-titles" >{props.traductions.kyc.form.finalmsg} </p>
                            <p className='link' onClick={() => props.data.history.push("/") }>{props.traductions.kyc.form.GoHome}</p>
                          </div>
                            :
                          <Row style={{display: 'flex' , justifyContent: 'center'}}>
                            <div className='wrapper-responsive-kyc'>
                              <div className='finish-kyc' style={{boxShadow: '2px 2px 8px #00000029'}}>
                                <span className='title-finish-kyc'>{props.traductions.kyc.form.finalmsg}</span>
                                <div style={{marginTop: '20px'}} className='subtitle-finish-kyc'>
                                  {props.traductions.kyc.form.subtitle1} <strong>{props.traductions.kyc.form.subtitle2 + ' '}</strong>
                                  {props.traductions.kyc.form.subtitle3}<strong>{ ' ' + props.traductions.kyc.form.subtitle4}</strong>
                                </div>
                                <div style={{whiteSpace: 'pre-wrap', marginTop: '40px', lineHeight: 2}} className='instructions-finish-kyc'>
                                  <div>
                                    {props.traductions.kyc.form.textWallet_1}
                                  </div>
                                  <div>
                                    {props.traductions.kyc.form.textWallet_2}
                                  </div>
                                  <div>
                                    {props.traductions.kyc.form.textWallet_3}
                                  </div>
                                  <div>
                                    {props.traductions.kyc.form.textWallet_4}
                                  </div>
                                </div>
                                <div style={{marginTop: '50px'}} className='text-finish-kyc'>
                                  {props.traductions.kyc.form.textWallet2} <strong>{props.traductions.kyc.form.textWallet3 + ' '}</strong>
                                  {props.traductions.kyc.form.textWallet4}
                                </div>
                                <div style={{marginTop: '50px', marginBottom: '20px'}} className='responsive-btn-finish'>
                                  <Button onClick={() => props.data.history.push({pathname: '/wallets', state: {modal_wallet: true}}) } className="btn-finish">{props.traductions.kyc.form.btnCreateWallet}</Button>
                                </div>
                              </div>
                            </div>
                          </Row>
                      }
                    </>
                )
            default:
                break;
        }
    }

    const styleRejectedField = (name, type) => {
        let style;
        let fields = dataReject.filter(reject => reject.name === name)

        if (fields.length > 0) {
            if (type === 'file') {
                style = "input_files_image_rejected "
            } else if (type === 'select'){
                style = "input-Country-rejected"
            } else {
                style = "input-Formulario-rejected"
            }
        } else {
            if (type === 'file') {
                style = "input_files_image"
            } else if(type === 'select'){
                style="input-Country"
            } else {
                style = "input-Formulario"
            }
        }
        return style
    }

    const labelReject = (name) => {
        let fields = dataReject.filter(reject => reject.name === name)
        if (fields.length > 0) {
            return "color-rejected"
        } else {
            return ""
        }
    }
    const cleanInputFile = (name) => {
        if (dataRejectArrived) {
            let fields = dataReject.filter(reject => reject.name === name)
            if (fields.length > 0) {
                return true
            } else {
                return false
            }
        }
    }

    const renderFormularioFisica = () => {
        let fields = (name) => dataReject.filter(el => el.name === name) ;
        return(
            <>
            <Row>
                <Col xs={12} sm={6}>
                    <Form.Group>
                        <Form.Label className={`label-blue-kyc ${labelReject("first_name")}`}>{props.traductions.kyc.form.general.Name} *</Form.Label>
                        <Form.Control value={DatosGenerales.first_name} onChange={updateDataGeneral} className={styleRejectedField('first_name')} type="text"  name='first_name' placeholder={props.traductions.kyc.form.general.Name} /> 
                    </Form.Group>
                </Col>
                <Col xs={12} sm={6}>
                    <Form.Group>
                        <Form.Label className={`label-blue-kyc ${labelReject("last_name_p")}`}>{props.traductions.kyc.form.general.Father_Surname} *</Form.Label>
                        <Form.Control value={DatosGenerales.last_name_p} onChange={updateDataGeneral} className={styleRejectedField('last_name_p')} type="text" name='last_name_p' placeholder={props.traductions.kyc.form.general.Father_Surname} />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={12} sm={6}>
                    <Form.Group>
                        <Form.Label className={`label-blue-kyc ${labelReject("last_name_m")}`}>{props.traductions.kyc.form.general.Mother_Surname} *</Form.Label>
                        <Form.Control value={DatosGenerales.last_name_m} onChange={updateDataGeneral} className={styleRejectedField('last_name_m')} type="text"  name='last_name_m' placeholder={props.traductions.kyc.form.general.Mother_Surname} />
                    </Form.Group>
                </Col>
                <Col xs={12} sm={6}>
                    <Form.Group>
                        <Form.Label className={`label-blue-kyc ${labelReject("birthdate")}`}>{props.traductions.kyc.form.general.Date_Birth} *</Form.Label>
                        <Form.Control
                            type="date"
                            className={styleRejectedField('birthdate')}
                            name='birthdate'
                            value={DatosGenerales.birthdate}
                            onChange={updateDataGeneral}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={12} sm={6}>
                    <Form.Group>
                        <Form.Label className={`label-blue-kyc ${labelReject("country")}`}>{props.traductions.kyc.form.general.Nationality} *</Form.Label>
                        <center>
                            <ReactFlagsSelect
                                ref={myRefCountry}
                                className={styleRejectedField('country', 'select')}
                                searchable={true}
                                placeholder={language === 'es' ? 'Seleccione un país': 'Select a country'}
                                searchPlaceholder={getPlaceholder()}
                                defaultCountry={(DatosGenerales.country !== '') && getCountryCode(DatosGenerales.country)}
                                selected={getCountryCode(DatosGenerales.country)}
                                onSelect={countryCode => updateDataGeneralDocs('country',getCountryName(countryCode))}
                            />
                        </center>
                    </Form.Group>
                </Col>

                <Col xs={12} sm={6}>
                    <Form.Group>
                        <Form.Label className={`label-blue-kyc ${labelReject("curp")}`}>CURP {(DatosGenerales.country == 'MX')?'*':'('+props.traductions.kyc.form.general.optional+')'} <Image src={HelpToolIcon} width={20} height={15} style={{marginTop: '-3px', cursor: 'pointer'}} onClick={() => handleHelpTool('curp')}/></Form.Label>
                        <Form.Control value={DatosGenerales.curp} onChange={updateDataGeneral}  className={styleRejectedField('curp')} type="text" name='curp' placeholder="CURP" />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={12} sm={6}>
                    <Form.Group>
                        <Form.Label className={`label-blue-kyc ${labelReject("rfc")}`}>
                          {getRfcLabel(DatosGenerales.country, Entity)}
                          <Image
                            src={HelpToolIcon}
                            width={20}
                            height={15}
                            style={{marginTop: '-3px', cursor: 'pointer'}}
                            onClick={() => handleHelpToolRfc('rfc', getRfcLabel(DatosGenerales.country, Entity))}
                          />
                        </Form.Label>
                        <Form.Control value={DatosGenerales.rfc} onChange={updateDataGeneral} className={styleRejectedField('rfc')} type="text"  name='rfc' placeholder={getRfcLabel(DatosGenerales.country, Entity)} />
                    </Form.Group>
                </Col>
                <Col xs={12} sm={6}>
                    <Form.Group>
                        <Form.Label className={`label-blue-kyc ${labelReject("economic_activity")}`}>{props.traductions.kyc.form.general.EconomicAct} *</Form.Label>
                        <Form.Control value={DatosGenerales.economic_activity} onChange={updateDataGeneral}  className={styleRejectedField('economic_activity')} type="text" name='economic_activity' placeholder={props.traductions.kyc.form.general.EconomicAct} />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={12} sm={6}>
                    <Form.Group>
                        <Form.Label className={`label-blue-kyc ${labelReject("id_number")}`}>{props.traductions.kyc.form.general.idPassportNum} * <Image src={HelpToolIcon} width={20} height={15} style={{marginTop: '-3px', cursor: 'pointer'}} onClick={() => handleHelpTool('id_number')}/></Form.Label>
                        <Form.Control value={DatosGenerales.id_number} onChange={updateDataGeneral} className={styleRejectedField('id_number')} type="text"  name='id_number' placeholder={props.traductions.kyc.form.general.idPassportNum} />
                    </Form.Group>
                </Col>
                <Col></Col>
            </Row>

            <hr/>

            <Row>
                <Col xl={4} md={6} className='virtual_exchange_dropdown'>
                <Form.Group >
                        <DropdownButton className="" title={(passportOrID == 'ID')?props.traductions.kyc.form.general.id:props.traductions.kyc.form.general.Passport} style={{marginBottom:10}}>
                            <Dropdown.Item onClick={()=>setPassportOrID('ID')} as="button">{props.traductions.kyc.form.general.id} *</Dropdown.Item>
                            <Dropdown.Item onClick={()=>setPassportOrID('Passport')} as="button">{props.traductions.kyc.form.general.Passport} *</Dropdown.Item>
                        </DropdownButton>
                        {
                            (passportOrID == 'ID')
                            ?
                                <Row>
                                    <Col md={6} style={{marginBottom: '10px'}}>
                                        <InputFile label={props.traductions.kyc.form.general.idFront} name={'f_id_front'} className={styleRejectedField('f_id_front', 'file')} image={ImgIDFront} setImage={e => updateDataGeneralDocs('ID_Front', e)} cleanInputFile={cleanInputFile('f_id_front')}/>
                                    </Col>
                                    <Col md={6}>
                                        <InputFile label={props.traductions.kyc.form.general.idBack} name={'f_id_back'} className={styleRejectedField('f_id_back', 'file')} image={ImgIDFront} setImage={e => updateDataGeneralDocs('ID_Back', e)} cleanInputFile={cleanInputFile('f_id_back')}/>
                                    </Col>
                                </Row>
                            :
                                <InputFile label={props.traductions.kyc.form.general.Passport} name={'f_passport'} className={styleRejectedField('f_passport', 'file')} image={ImgIDFront} setImage={e => updateDataGeneralDocs('ID_Front', e)} cleanInputFile={cleanInputFile('f_passport')}/>
                        }

                    </Form.Group>
                </Col>
                <Col xl={4} md={6}>
                    <Form.Group>
                        <Form.Label className={`label-blue-kyc ${labelReject("f_id_selfie")}`} style={{height:42}}>{props.traductions.kyc.form.general.selfieID} * <Image src={HelpToolIcon} width={20} height={15} style={{marginTop: '-3px', cursor: 'pointer'}} onClick={() => handleHelpTool('f_id_selfie')}/></Form.Label>
                        <InputFile  label={props.traductions.kyc.form.general.selfieID} name={'f_id_selfie'} className={styleRejectedField('f_id_selfie', 'file')} image={ImgIDFront} setImage={e => updateDataGeneralDocs('Selfie', e)} cleanInputFile={cleanInputFile('f_id_selfie')}/>
                    </Form.Group>
                </Col>
                <Col xl={4} md={6}>
                    <Form.Group>
                        <Form.Label className={`label-blue-kyc ${labelReject("f_rfc")}`} style={{height:42}}>{getRfcLabel(DatosGenerales.country, Entity)} *
                          <Image
                            src={HelpToolIcon}
                            width={20}
                            height={15}
                            style={{marginTop: '-3px', cursor: 'pointer'}}
                            onClick={() => handleHelpToolRfc('rfc', getRfcLabel(DatosGenerales.country, Entity))}/>
                        </Form.Label>
                        <InputFile country={DatosGenerales.country} label={props.traductions.kyc.form.general.fiscalID} name={'f_rfc'} className={styleRejectedField('f_rfc', 'file')} image={ImgIDFront} setImage={e => updateDataGeneralDocs('doc_RFC', e)} cleanInputFile={cleanInputFile('f_rfc')}/>
                    </Form.Group>
                </Col>
            </Row>

            <Row style={{justifyContent:'flex-end', margin: '10px 0'}} >
                <Button className="continue-btn" disabled={Loading} onClick={()=>Final()}>
                    {
                        (Loading)
                        ? <Bounce size={20} color={"#FFFFFF"} animating={true} />
                        : props.traductions.kyc.form.general.Continue
                    }
                </Button>
            </Row>
        </>
        )
    }

    const renderFormularioMoral = () => {
        let fields = (name) => dataReject.filter(el => el.name === name) ;
        return(
            <>
                <Row>
                    <Col xs={12} sm={6}>
                        <Form.Group>
                            <Form.Label className={`label-blue-kyc ${labelReject("company_name")}`}>{props.traductions.kyc.form.moral.Business_Name} * <Image src={HelpToolIcon} width={20} height={15} style={{marginTop: '-3px', cursor: 'pointer'}} onClick={() => handleHelpTool('company_name')}/></Form.Label>
                            <Form.Control value={DatosGeneralesMoral.company_name} onChange={updateDataGeneralesMoral} className={styleRejectedField('company_name')} type="text"  name='company_name' placeholder={props.traductions.kyc.form.moral.Business_Name}/>
                        </Form.Group>
                    </Col>
                    <Col xs={12} sm={6}>
                        <Form.Group>
                            <Form.Label className={`label-blue-kyc ${labelReject("birthdate")}`}>{props.traductions.kyc.form.moral.Date_Incorporation} * <Image src={HelpToolIcon} width={20} height={15} style={{marginTop: '-3px', cursor: 'pointer'}} onClick={() => handleHelpTool('birthdate_company')}/></Form.Label>
                            <Form.Control
                                type="date"
                                className={styleRejectedField('birthdate')}
                                name='birthdate'
                                value={DatosGeneralesMoral.birthdate} onChange={updateDataGeneralesMoral}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={6}>
                        <Form.Group>
                            <Form.Label className={`label-blue-kyc ${labelReject("rfc")}`}>
                              {getRfcLabel(DatosGeneralesMoral.country, Entity)} * 
                              <Image
                                src={HelpToolIcon}
                                width={20}
                                height={15}
                                style={{marginTop: '-3px', cursor: 'pointer'}}
                                onClick={() => handleHelpTool('rfc_company', getRfcLabel(DatosGeneralesMoral.country, Entity))}/>
                            </Form.Label>
                            <Form.Control value={DatosGeneralesMoral.rfc} onChange={updateDataGeneralesMoral} className={styleRejectedField('rfc')} type="text"  name='rfc' placeholder={getRfcLabel(DatosGeneralesMoral.country, Entity)} />
                        </Form.Group>
                    </Col>
                    <Col xs={12} sm={6}>
                        <Form.Group>
                            <Form.Label className={`label-blue-kyc ${labelReject("country")}`}>{props.traductions.kyc.form.moral.country} * <Image src={HelpToolIcon} width={20} height={15} style={{marginTop: '-3px', cursor: 'pointer'}} onClick={() => handleHelpTool('country_incorporation')}/></Form.Label>
                            <center>
                                <ReactFlagsSelect
                                    ref={myRefCountryMoral}
                                    className={styleRejectedField('country', 'select') || "input-Country"}
                                    searchable={true}
                                    placeholder={language === 'es' ? 'Seleccione un país': 'Select a country'}
                                    searchPlaceholder={getPlaceholder()}
                                    defaultCountry={(DatosGeneralesMoral.country != '')&&getCountryCode(DatosGeneralesMoral.country)}
                                    selected={getCountryCode(DatosGeneralesMoral.country)}
                                    onSelect={countryCode => updateDataGeneralesMoralDocs('country',getCountryName(countryCode))}
                                />
                            </center>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={6}>
                        <Form.Group>
                            <Form.Label className={`label-blue-kyc ${labelReject("business_line")}`}>{props.traductions.kyc.form.moral.Line_Business} *</Form.Label>
                            <Form.Control value={DatosGeneralesMoral.business_line} onChange={updateDataGeneralesMoral} className={styleRejectedField('business_line')} type="text"  name='business_line' placeholder={props.traductions.kyc.form.moral.Line_Business} />
                        </Form.Group>
                    </Col>
                    <Col>

                    </Col>
                </Row>

                <hr/>
                <p style={{fontSize: 20, color: '#707070'}}>{props.traductions.kyc.form.moral.part2}</p>
                <Row>
                    <Col xs={12} sm={6}>
                        <Form.Group>
                            <Form.Label className={`label-blue-kyc ${labelReject("first_name")}`}>{props.traductions.kyc.form.general.Name} *</Form.Label>
                            <Form.Control value={DatosGeneralesMoral.first_name} onChange={updateDataGeneralesMoral} className={styleRejectedField('first_name')} type="text"  name='first_name' placeholder={props.traductions.kyc.form.general.Name} />
                        </Form.Group>
                    </Col>
                    <Col xs={12} sm={6}>
                        <Form.Group>
                            <Form.Label className={`label-blue-kyc ${labelReject("last_name_p")}`}>{props.traductions.kyc.form.general.Father_Surname} *</Form.Label>
                            <Form.Control value={DatosGeneralesMoral.last_name_p} onChange={updateDataGeneralesMoral}  className={styleRejectedField('last_name_p')} type="text" name='last_name_p' placeholder={props.traductions.kyc.form.general.Father_Surname} />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={6}>
                        <Form.Group>
                            <Form.Label className={`label-blue-kyc ${labelReject("last_name_m")}`}>{props.traductions.kyc.form.general.Mother_Surname} *</Form.Label>
                            <Form.Control value={DatosGeneralesMoral.last_name_m} onChange={updateDataGeneralesMoral} className={styleRejectedField('last_name_m')} type="text"  name='last_name_m' placeholder={props.traductions.kyc.form.general.Mother_Surname} />
                        </Form.Group>
                    </Col>
                    <Col xs={12} sm={6}>
                        <Form.Group>
                            <Form.Label className={`label-blue-kyc ${labelReject("birthdate_rep")}`}>{props.traductions.kyc.form.general.Date_Birth} ({props.traductions.kyc.form.general.optional})</Form.Label>
                            <Form.Control
                                type="date"
                                className={styleRejectedField('birthdate_rep')}
                                name='birthdate_rep'
                                value={DatosGeneralesMoral.birthdate_rep} onChange={updateDataGeneralesMoral}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={6}>
                        <Form.Group>
                            <Form.Label className={`label-blue-kyc ${labelReject("country_rep")}`}>{props.traductions.kyc.form.general.Country_Birth} *</Form.Label>
                            <center>
                                <ReactFlagsSelect
                                    ref={myRefCountryRep}
                                    className={styleRejectedField('country_rep', 'select') || "input-Country"}
                                    searchable={true}
                                    placeholder={language === 'es' ? 'Seleccione un país': 'Select a country'}
                                    searchPlaceholder={getPlaceholder()}
                                    selected={getCountryCode(DatosGeneralesMoral.country_rep)}
                                    defaultCountry={(DatosGeneralesMoral.country_rep != '')&&getCountryCode(DatosGeneralesMoral.country_rep)}
                                    onSelect={countryCode => updateDataGeneralesMoralDocs('country_rep',getCountryName(countryCode))}
                                />
                            </center>
                        </Form.Group>
                    </Col>

                    <Col xs={12} sm={6}>
                        <Form.Group>
                            <Form.Label className={`label-blue-kyc ${labelReject("curp")}`}>CURP {(DatosGeneralesMoral.country_rep == 'MX')?'*':'(optional)'} <Image src={HelpToolIcon} width={20} height={15} style={{marginTop: '-3px', cursor: 'pointer'}} onClick={() => handleHelpTool('curp')}/></Form.Label>
                            <Form.Control value={DatosGeneralesMoral.curp} onChange={updateDataGeneralesMoral}  className={styleRejectedField('curp')} type="text" name='curp' placeholder="CURP" />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={6}>
                        <Form.Group>
                            <Form.Label className={`label-blue-kyc ${labelReject("rfc_rep")}`}>{getRfcLabel(DatosGeneralesMoral.country_rep, Entity) } * <Image src={HelpToolIcon} width={20} height={15} style={{marginTop: '-3px', cursor: 'pointer'}} onClick={() => handleHelpTool('rfc_company', getRfcLabel(DatosGeneralesMoral.country_rep, Entity) )}/></Form.Label>
                            <Form.Control value={DatosGeneralesMoral.rfc_rep} onChange={updateDataGeneralesMoral}  className={styleRejectedField('rfc_rep')} type="text" name='rfc_rep' placeholder={getRfcLabel(DatosGeneralesMoral.country_rep, Entity)} />
                        </Form.Group>
                    </Col>
                    <Col xs={12} sm={6}>
                        <Form.Group>
                            <Form.Label className={`label-blue-kyc ${labelReject("id_number")}`}>{props.traductions.kyc.form.general.idPassportNum} * <Image src={HelpToolIcon} width={20} height={15} style={{marginTop: '-3px', cursor: 'pointer'}} onClick={() => handleHelpTool('id_number')}/></Form.Label>
                            <Form.Control value={DatosGeneralesMoral.id_number} onChange={updateDataGeneralesMoral} className={styleRejectedField('id_number')} type="text"  name='id_number' placeholder={props.traductions.kyc.form.general.idPassportNum} />
                        </Form.Group>
                    </Col>
                </Row>

                <hr/>

                <Row>
                    <Col xl={4} md={6} className='virtual_exchange_dropdown'>
                        <Form.Group >
                            <DropdownButton className="" title={(passportOrID == 'ID')?props.traductions.kyc.form.general.id:props.traductions.kyc.form.general.Passport} style={{marginBottom:18}}>
                                <Dropdown.Item onClick={()=>setPassportOrID('ID')} as="button">{props.traductions.kyc.form.general.id} *</Dropdown.Item>
                                <Dropdown.Item onClick={()=>setPassportOrID('Passport')} as="button">{props.traductions.kyc.form.general.Passport} *</Dropdown.Item>
                            </DropdownButton>
                            {
                                (passportOrID == 'ID')
                                ?
                                    <Row>
                                        <Col md={6} style={{marginBottom: '10px'}}>
                                            <InputFile label={props.traductions.kyc.form.general.idFront} name={'f_id_front'} className={styleRejectedField('f_id_front', 'file')} cleanField={fields("f_id_front").length > 0} status={DatosGeneralesMoral.f_id_front} image={ImgIDFront} setImage={e => updateDataGeneralesMoralDocs('f_id_front', e)} cleanInputFile={cleanInputFile('f_id_front')}/>
                                        </Col>
                                        <Col md={6}>
                                            <InputFile label={props.traductions.kyc.form.general.idBack} name={'f_id_back'} className={styleRejectedField('f_id_back', 'file')} cleanField={fields("f_id_back").length > 0} status={DatosGeneralesMoral.f_id_back} image={ImgIDFront} setImage={e => updateDataGeneralesMoralDocs('f_id_back', e)} cleanInputFile={cleanInputFile('f_id_back')}/>
                                        </Col>
                                    </Row>
                                :
                                    <InputFile label={props.traductions.kyc.form.general.Passport} name={'f_passport'} status={DatosGeneralesMoral.f_id_front} image={ImgIDFront} setImage={e => updateDataGeneralesMoralDocs('f_id_front', e)} cleanInputFile={cleanInputFile('f_id_front')}/>
                            }

                        </Form.Group>
                    </Col>
                    <Col xl={4} md={6}>
                        <Form.Group>
                            <Form.Label className={`label-blue-kyc ${labelReject("f_id_selfie")}`} style={{height:50}}>{props.traductions.kyc.form.general.selfieID} * <Image src={HelpToolIcon} width={20} height={15} style={{marginTop: '-3px', cursor: 'pointer'}} onClick={() => handleHelpTool('f_id_selfie')}/></Form.Label>
                            <InputFile label={props.traductions.kyc.form.general.selfieID} name={'f_id_selfie'} className={styleRejectedField('f_id_selfie', 'file')} status={DatosGeneralesMoral.f_id_selfie} image={ImgIDFront} setImage={e => updateDataGeneralesMoralDocs('f_id_selfie', e)} cleanInputFile={cleanInputFile('f_id_selfie')}/>
                        </Form.Group>
                    </Col>
                    <Col xl={4} md={6}>
                        <Form.Group>
                            <Form.Label className={`label-blue-kyc ${labelReject("f_rfc")}`} style={{height:50}}>{getRfcLabel(DatosGeneralesMoral.country, Entity)} ({props.traductions.kyc.form.moral.company}) * <Image src={HelpToolIcon} width={20} height={15} style={{marginTop: '-3px', cursor: 'pointer'}} onClick={() => handleHelpTool('rfc_company', getRfcLabel(DatosGeneralesMoral.country, Entity))}/></Form.Label>
                            <InputFile countryInc={DatosGeneralesMoral.country} label={`${props.traductions.kyc.form.general.fiscalID}  (${props.traductions.kyc.form.moral.company})`} name={'f_rfc'} className={styleRejectedField('f_rfc', 'file')} status={DatosGeneralesMoral.f_rfc} image={ImgIDFront} setImage={e => updateDataGeneralesMoralDocs('f_rfc', e)} cleanInputFile={cleanInputFile('f_rfc')}/>
                        </Form.Group>
                    </Col>
                    <Col xl={4} md={6}>
                        <Form.Group>
                            <Form.Label className={`label-blue-kyc ${labelReject("f_rfc_rep")}`} style={{height:50}}>{getRfcLabel(DatosGeneralesMoral.country_rep, Entity)} ({props.traductions.kyc.form.moral.legalRep}) *</Form.Label>
                            <InputFile countryRep={DatosGeneralesMoral.country_rep} label={`${props.traductions.kyc.form.general.fiscalID} (${props.traductions.kyc.form.moral.legalRep})`} name={'f_rfc_rep'} className={styleRejectedField('f_rfc_rep', 'file')} status={DatosGeneralesMoral.f_rfc_rep} image={ImgIDFront} setImage={e => updateDataGeneralesMoralDocs('f_rfc_rep', e)} cleanInputFile={cleanInputFile('f_rfc_rep')}/>
                        </Form.Group>
                    </Col>
                    <Col xl={4} md={6}>
                        <Form.Group>
                            <Form.Label className={`label-blue-kyc ${labelReject("f_constitutive_act")}`} style={{height:50}}>{props.traductions.kyc.form.general.Articles_Incorporation} * <Image src={HelpToolIcon} width={20} height={15} style={{marginTop: '-3px', cursor: 'pointer'}} onClick={() => handleHelpTool('f_constitutive_act')}/></Form.Label>
                            <InputFile label={props.traductions.kyc.form.general.Articles_Incorporation} name={'f_constitutive_act'} className={styleRejectedField('f_constitutive_act', 'file')} status={DatosGeneralesMoral.f_constitutive_act} image={ImgIDFront} setImage={e => updateDataGeneralesMoralDocs('f_constitutive_act', e)} cleanInputFile={cleanInputFile('f_constitutive_act')}/>
                        </Form.Group>
                    </Col>
                    <Col xl={4} md={6}>
                        <Form.Group>
                            <Form.Label className={`label-blue-kyc ${labelReject("f_last_constitutive_act")}`} style={{height:50}}>{props.traductions.kyc.form.general.Last_Articles_Incorporation} ({props.traductions.kyc.form.general.optional})</Form.Label>
                            <InputFile label={props.traductions.kyc.form.general.Last_Articles_Incorporation} name={'f_last_constitutive_act'} className={styleRejectedField('f_last_constitutive_act', 'file')} status={DatosGeneralesMoral.f_last_constitutive_act} image={ImgIDFront} setImage={e => updateDataGeneralesMoralDocs('f_last_constitutive_act', e)} cleanInputFile={cleanInputFile('f_last_constitutive_act')}/>
                        </Form.Group>
                    </Col>
                    <Col xl={4} md={6}>
                        <Form.Group>
                            <Form.Label className={`label-blue-kyc ${labelReject("f_public_register")}`} style={{height:50}}>{props.traductions.kyc.form.moral.Public_register} {(DatosGeneralesMoral.country == 'MX')?'*':'(optional)'}</Form.Label>
                            <InputFile label={props.traductions.kyc.form.moral.Public_register} name={'f_public_register'} className={styleRejectedField('f_public_register', 'file')} status={DatosGeneralesMoral.f_public_register} image={ImgIDFront} setImage={e => updateDataGeneralesMoralDocs('f_public_register', e)} cleanInputFile={cleanInputFile('f_public_register')}/>
                        </Form.Group>
                    </Col>
                </Row>
                <Row style={{justifyContent:'flex-end', margin: '10px 0'}} >
                    <Button className="continue-btn" disabled={Loading} onClick={()=>Final()}>
                        {
                            (Loading)
                            ? <Bounce size={20} color={"#FFFFFF"} animating={true} />
                            : props.traductions.kyc.form.general.Continue
                        }
                    </Button>
                </Row>
            </>
        )
    }

    const renderPlans = () =>{
      return(
          <div>
              {windowSize.width >= 992 &&
                <>
                  <p style={{ fontSize: 30 , textAlign:'center', marginBottom:'10px', color: '#312D2D'}}>{props.traductions.kyc.choose.title}</p>
                  <p style={{ fontSize: 18 , color: '#959595', marginBottom:'30px',textAlign:'center', whiteSpace: 'pre'}} className="title-container-shadow">{props.traductions.kyc.choose.subtitle}</p>
                  <Container className='large-screen'>
                    <Row>
                      <Col xs={12} sm={12} md={6} xl={6}>
                        <Card
                          style={{opacity: status === 'False' || requestAcc === 'personal' && Chosen=='' || Chosen === 'personal' ? 1 : 0.5, padding: '10px 15px'}}
                          className={(Chosen=='personal')?' container-Kyc-card choosed':'container-Kyc-card'}
                        >
                          <div style={{marginTop: 15, marginBottom: 20}}>
                            <span className='title-register-card'>{props.traductions.kyc.choose.physical}</span>
                          </div>
                          <div>
                            <span className='subtitle-register-card'>
                              {props.traductions.kyc.choose.description}
                            </span>
                          </div>
                          <Row style={{display:'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-evenly', alignItems: 'center', marginTop: 45, height: '150px'}}>
                              <Col xs={3} style={{textAlign: 'center'}}>
                                <Image src={IconPhysics} height={'90%'} width={'100%'}/>
                              </Col>
                              <Col xs={9} style={{lineHeight: 2}}>
                                  <span style={{fontSize: '14px', color: '#312D2D'}}>1. {props.traductions.kyc.choose.p_req}</span><br />
                                  <span style={{fontSize: '14px', color: '#312D2D'}}>2. {props.traductions.kyc.choose.p_req1}</span><br />
                                  <span style={{fontSize: '14px', color: '#312D2D'}}>3. {props.traductions.kyc.choose.p_req2}</span><br />
                                  <span style={{fontSize: '14px', color: '#312D2D'}}>4. {props.traductions.kyc.choose.p_req3}</span><br />
                                  <span style={{fontSize: '14px', color: '#312D2D'}}>5. {props.traductions.kyc.choose.p_req4}</span><br />
                              </Col>
                            </Row>
                            {
                              (status === 'False' || requestAcc === 'personal' && Chosen=='' )?
                              <div className='flex-btn-responsive'>
                                <Button className="Btn_choosePlan" style={{width: '260px'}} onClick={()=>{ ChoosePlan('F'); }}>
                                  {props.traductions.kyc.choose.L_Continue}
                                </Button>
                              </div>
                              :(Chosen=='personal')&& <p className='title-container-shadow'>{props.traductions.kyc.choose.youHave}</p>
                            }
                        </Card>
                      </Col>
                      <Col xs={12} sm={12} md={6} xl={6}>
                          <Card 
                            style={{opacity: status === 'False' || requestAcc === 'business' && Chosen=='' ? 1 : 0.5, padding: '10px 15px'}}
                            className={(Chosen=='business')?' container-Kyc-card choosed':'container-Kyc-card'}
                          >
                            <div style={{marginTop: 15, marginBottom: 20}}>
                              <span className='title-register-card'>{props.traductions.kyc.choose.moral}</span>
                            </div>
                            <div>
                              <span className='subtitle-register-card'>
                                {props.traductions.kyc.choose.description}
                              </span>
                            </div>
                            <Row style={{display:'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between', marginTop: 45}}>
                              <Col xs={3} style={{paddingTop: 20}}>
                                <Image src={IconMoral} height={130} width={130}/>
                              </Col>
                              <Col xs={8} style={{lineHeight: 2}}>
                                <span style={{fontSize: '14px', color: '#312D2D'}}>1. {props.traductions.kyc.choose.m_req_0}</span><br />
                                <span style={{fontSize: '14px', color: '#312D2D'}}>2. {props.traductions.kyc.choose.m_req}</span><br />
                                <span style={{fontSize: '14px', color: '#312D2D'}}>3. {props.traductions.kyc.choose.m_req1}</span><br />
                                <span style={{fontSize: '14px', color: '#312D2D'}}>4. {props.traductions.kyc.choose.m_req2}</span><br />
                                <span style={{fontSize: '14px', color: '#312D2D'}}>5. {props.traductions.kyc.choose.m_req3}</span><br />
                                <span style={{fontSize: '14px', color: '#312D2D'}}>6. {props.traductions.kyc.choose.m_req4}</span><br />
                                <span style={{fontSize: '14px', color: '#312D2D'}}>7. {props.traductions.kyc.choose.m_req5}</span><br />
                              </Col>
                            </Row>
                            {
                              (status === 'False' || requestAcc === 'business' && Chosen=='' )?
                              <div className='flex-btn-responsive'>
                                <Button className="Btn_choosePlan" style={{width: '260px'}} onClick={()=>{ ChoosePlan('M'); }}>
                                  {props.traductions.kyc.choose.L_Continue}
                                </Button>
                              </div>
                              : Chosen=='business' && <p className='title-container-shadow'>{props.traductions.kyc.choose.youHave}</p>
                            }
                          </Card>
                      </Col>
                    </Row>
                  </Container>
                </>
              }
              {
                windowSize.width <= 991 &&
                <Container className='wrapper-mobile'>
                  <div style={{textAlign: 'center', marginBottom: '8px'}}>
                    <span style={{fontSize: '14px', color: '#312D2D', fontFamily: 'DMSans-Medium'}}>{props.traductions.kyc.choose.title_mobile}</span>
                  </div>
                  <div style={{marginBottom: '30px', textAlign: 'center'}}>
                    <span style={{whiteSpace: 'pre', fontSize: '14px', color: '#959595'}}>{props.traductions.kyc.choose.subtitle}</span>
                  </div>
                  <Row>
                    <Col xs={12} style={{marginBottom: '20px'}}>
                      <Card
                        onClick={requestAcc === '-'  ? () => setEntityMobile('F'): null}
                        style={{opacity: requestAcc === 'personal' || entityMobile === 'F' ? 1 : 0.5, padding: '10px 15px'}}
                        className={(requestAcc=='personal')?' container-Kyc-card-mobile choosed':'container-Kyc-card-mobile'}
                      >
                        <div>
                          <span className='title-register-card-mobile'>{props.traductions.kyc.choose.physical}</span>
                        </div>
                        <div style={{display: 'flex', marginBottom: '10px'}}>
                          <div style={{marginRight: '30px'}}>
                            <Image src={IconPhysics}  width={'45px'} height={'65px'} style={{position: 'relative', left:'-5px'}}/>
                          </div>
                          <div style={{position: 'relative', left:'-10px'}}>
                            <p style={{fontSize: '10px', color: '#312D2D', marginBottom: 0}}>1. {props.traductions.kyc.choose.p_req}</p>
                            <p style={{fontSize: '10px', color: '#312D2D', marginBottom: 0}}>2. {props.traductions.kyc.choose.p_req1}</p>
                            <p style={{fontSize: '10px', color: '#312D2D', marginBottom: 0}}>3. {props.traductions.kyc.choose.p_req2}</p>
                            <p style={{fontSize: '10px', color: '#312D2D', marginBottom: 0}}>4. {props.traductions.kyc.choose.p_req3}</p>
                            <p style={{fontSize: '10px', color: '#312D2D', marginBottom: 0}}>5. {props.traductions.kyc.choose.p_req4}</p>
                          </div>
                        </div>
                        {
                            Chosen === 'personal' && <p className='title-container-shadow' style={{fontSize: '10px'}}>{props.traductions.kyc.choose.youHave}</p>
                        }
                      </Card>
                    </Col>
                    <Col xs={12}>
                      <Card
                        onClick={requestAcc === '-'  ? () => setEntityMobile('M') : null}
                        style={{opacity: requestAcc === 'business' || entityMobile === 'M'? 1 : 0.5, padding: '10px 15px'}}
                        className={(requestAcc=='business')? 'container-Kyc-card-mobile choosed':'container-Kyc-card-mobile'}
                      >
                        <div style={{display: 'flex', marginBottom: '10px'}}>
                          <div style={{display: 'flex', alignItems: 'center', marginRight: '30px', position: 'relative', left: '-2px'}}>
                            <Image src={IconMoral}  width={'45px'} height={'65px'}/>
                          </div>
                          <div className='moral-requirements-responsive'>
                          <span className='title-register-card-mobile'>{props.traductions.kyc.choose.moral}</span>
                            <p style={{fontSize: '10px', color: '#312D2D', marginBottom: 0}}>1. {props.traductions.kyc.choose.m_req_0}</p>
                            <p style={{fontSize: '10px', color: '#312D2D', marginBottom: 0}}>2. {props.traductions.kyc.choose.m_req}</p>
                            <p style={{fontSize: '10px', color: '#312D2D', marginBottom: 0}}>3. {props.traductions.kyc.choose.m_req1}</p>
                            <p style={{fontSize: '10px', color: '#312D2D', marginBottom: 0}}>4. {props.traductions.kyc.choose.m_req2}</p>
                            <p style={{fontSize: '10px', color: '#312D2D', marginBottom: 0}}>5. {props.traductions.kyc.choose.m_req3}</p>
                            <p style={{fontSize: '10px', color: '#312D2D', marginBottom: 0}}>6. {props.traductions.kyc.choose.m_req4}</p>
                            <p style={{fontSize: '10px', color: '#312D2D', marginBottom: 0}}>7. {props.traductions.kyc.choose.m_req5}</p>
                          </div>
                        </div>
                        {
                            Chosen === 'business' && <p className='title-container-shadow' style={{fontSize: '10px'}}>{props.traductions.kyc.choose.youHave}</p>
                        }
                      </Card>
                    </Col>
                  </Row>
                  <Row style={{marginTop: '46px'}}>
                    <Col>
                      <Button disabled={entityMobile === '' || Chosen !== ''} style={{width: '100%'}} className="Btn_choosePlan" onClick={()=>{ ChoosePlan(entityMobile); }}>
                        {props.traductions.kyc.choose.L_Continue}
                      </Button>
                    </Col>
                  </Row>
                </Container>
              }
          </div>
      )
    }

    const renderModalValidateCellphone = () => {
        return(
            <Modal className="modal-signup-resend-email" centered aria-labelledby="contained-modal-title-vcenter" show={showModal} onHide={() => { setshowModal(false) }}>
                <Modal.Body>
                    {
                        (CodeSent)
                        ?
                            <>
                                <div className="border-title-separator-container">
                                    <div className="border-title-separator-container-left">
                                    <p className="title-container-shadow">{props.traductions.kyc.choose.M_cell_title}</p>
                                    </div>
                                </div>
                                <div className="modal_container_cellphone_validation">
                                    <p>{props.traductions.kyc.choose.M_cell_note}.</p>
                                    <br/>
                                    <p className="">{props.traductions.kyc.choose.M_cell_code}:</p>
                                    <Form.Control
                                        type="number"
                                        max={99999}
                                        placeholder={props.traductions.kyc.choose.M_cell_CaptureCode}
                                        className="input-signup"
                                        value={Code}
                                        onChange={(codeValidate) => {setCode(codeValidate.target.value)}}
                                    />
                                </div>
                                <div className="modal_container_cellphone_validation_button">
                                    <Button className="steps-button-wallet-general" disabled={Loading} onClick={() => { ValidatePhone() }}>
                                        {
                                            (Loading)
                                            ? <Bounce size={20} color={"#FFFFFF"} animating={true} />
                                            : props.traductions.kyc.choose.M_cell_valid
                                        }
                                    </Button>
                                </div>
                                <div style={{textAlign:'center'}}>
                                    <p className='link' onClick={()=>{ SendCode() }} style={{marginTop:'1em'}}>{props.traductions.kyc.choose.M_cell_resend} ↻</p>
                                    <p className='link' onClick={()=>{ setCodeSent(false) }} >{props.traductions.kyc.choose.M_cell_change} </p>
                                </div>
                            </>
                        :
                            <>
                                <div className="border-title-separator-container">
                                    <div className="border-title-separator-container-left">
                                    <p className="title-container-shadow">{props.traductions.kyc.choose.M_cell_verif}</p>
                                    </div>
                                </div>
                                <div className="modal_container_cellphone_validation">
                                    <p>{props.traductions.kyc.choose.M_cell_note2}.</p>
                                    <br/>
                                    <p className="">{props.traductions.kyc.choose.M_cell_phone}:</p>
                                    <PhoneInput
                                        country="mx"
                                        value={Cellphone.cellphone}
                                        enableSearch={true}
                                        inputProps={{maxLength: limit}}
                                        onChange={(a, b) => { handleChangeCellphone(a, b) }}
                                    />
                                </div>
                                <div className="modal_container_cellphone_validation_button">
                                    <Button className="steps-button-wallet-general" disabled={Loading} onClick={() => { SendCode() }}>
                                        {
                                            (Loading)
                                            ? <Bounce size={20} color={"#FFFFFF"} animating={true} />
                                            : props.traductions.kyc.choose.M_cell_btn
                                        }
                                    </Button>
                                </div>
                            </>
                    }

                </Modal.Body>
            </Modal>
        )
    }

    return (
        <div>
            <NavbarComponent data={props} selected="/" logged={true} />
            <RenovateTokenAlert data={props} />
            <div className="contenedor-wallets-generals" style={{marginTop: '75px'}}>
                {
                    (Entity == '')
                    ?   renderPlans()
                    :   <Col lg={{span:10, offset:1}}>{renderForms()}</Col>
                }
            </div>
                {renderModalValidateCellphone()}
            {
                Paso === 2 && showContract &&
                <Contract
                    show={showContract}
                    handleClose={()=>setshowContract(false)}
                    data={DataContract}
                    uploadContract={(contract) => uploadContract(contract)}
                    Loading={Loading}
                    traductions={props.traductions}
                    callFinal={(e)=> {Final(e)}}
                    register_client_data={(e) => {register_client_data(e)}}
                />
            }
            <HelpTool
              {...props}
              handleClose={() => {setModalHelp(false); setTypeHelp('')}}
              show={modalHelp}
              typeHelp={typeHelp}
              rfcLabel={labelRfc}
            />
            <HelpToolRfc
              {...props}
              handleClose={() => {setModalHelpRfc(false)}}
              show={modalHelpRfc}
              entity={Entity}
              typeHelpRfc={typeHelpRfc}
              country={DatosGenerales.country}
              countryInc={DatosGeneralesMoral.country}
              countryRep={DatosGeneralesMoral.country_rep}
              labelRfc={labelRfc}
            />
        </div>
    );
}

export default Kyc;
